import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import queryString from 'query-string';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'
import ReactGA from 'react-ga';

import { doEmailConfirmationThunk, setFakeLoginState, fakeAuth } from '../actions/auth'
import Loading from '../components/loading'

// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'

import NavBar from '../components/navbar'
import '../css/styles.css';

class EmailVerificationScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            completedStep2: false,
            step2Error: false,
            step2ErrorMessage: null,
            completedStep2: false,
            errCode: null,
            isLoading: true
        };
    }

    componentDidMount(){
        console.log ("Component mounted...");
        this.callValidationAPI();
    }
      

    componentDidUpdate(prevProps, prevState){
        console.log("componentDidUpdate called...");
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            
            if(this.state.errCode === 'CUE'){
                this.setState({step2Error: true, step2ErrorMessage: this.props.strings.REG_ERROR_CREATE_USER});
            } else if(this.state.errCode === 'UNF'){
                this.setState({step2Error: true, step2ErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE});
            } else if(this.state.errCode === 'UE') {
                this.setState({step2Error: true, step2ErrorMessage: this.props.strings.REG_ERROR_MESSAGE});
            }
        }
    }

    getUrlParams() {
        let params = queryString.parse(this.props.location.search);
        return { token: params.token };
    }

    callValidationAPI () {
        this.setState({step2Error: false, step2ErrorMessage: null});
        let token = this.getUrlParams();
        this.props.dispatch(doEmailConfirmationThunk(token))
            .then(() => {
                setTimeout(() => {
                    this.setState({ completedStep2: true });
                }, 1000);
                this.setState({isLoading: false});
                ReactGA.event({
                    category: 'Registration event',
                    action: 'Email confirmation',
                    label: 'email-confirm'
                });
            })
            .catch(err => {
                // FIXME Handle errors here!
                this.setState({isLoading:false});
                if(err.code === 'CUE'){
                    this.setState({step2Error: true, step2ErrorMessage: this.props.strings.REG_ERROR_CREATE_USER, errCode: err.code});
                } else if(err.code === 'UNF'){
                    this.setState({step2Error: true, step2ErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE, errCode: err.code});
                } else {
                    this.setState({step2Error: true, step2ErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                }
            });;
    }

    handleSubmit = (e) => {
        console.log("Handle submit called...");
        e.preventDefault();
        this.props.history.push("/");
    }

    // FIXME Not sure what should go here?
    renderError(key) {
        if (this.state.errors[key])  {
            return (
                <div className="invalid-feedback">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    renderEmailVerificationError() {
        if (this.state.step2Error === false || this.state.step2ErrorMessage === null) {
            return null;
        } else {
            return (
                <div>
                    <span style={{color: 'red', fontWeight: 'bold'}}>Error: {this.state.step2ErrorMessage}</span>
                </div>
            );
        }
    }

    validate(dto) {
        let error = null;
        // Check required fields..
        // All fields are required right now.
        Object.entries(dto).forEach((o) => {
            if (o == null) {
                error = this.props.strings.MISSING_REQUIRED_FIELDS;
            }
        });

        // Check for errors.
        Object.entries(this.state.errors).forEach((e) => {
            if (e[1] !== null) {
                error = e;
            }
        });
        return error;
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } else if (this.props.isLoadingRegister === true || this.state.isLoading) {
            return <Loading />
        } else if (this.state.step2Error == true){
            return(
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container justify-content-center align-items-center">
                    <div class="alert alert-info" role="alert">
                        <span style={{color: 'red', fontWeight: 'bold'}}>Error: {this.state.step2ErrorMessage}</span>
                    </div>
                </div>
                <Footer />
            </div>)
        }

        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container justify-content-center align-items-center">
                    <div class="alert alert-info" role="alert">
                        <h5>{this.props.strings.REGISTER_VERIFY_LABEL}</h5>
                        <p>{this.props.strings.REGISTER_VERIFY_MESSAGE}</p>
                    </div>
                    <form onSubmit={this.handleSubmit} className="formMargin">
                        {this.renderEmailVerificationError()}
                        <div className="row justify-content-center">
                            <button type="submit" class={ "btn btn-primary custom-button" } >
                                {this.props.strings.LOGIN_NOW_LABEL}
                            </button>
                        </div>
                    </form>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isChangedError: state.auth.isChangedError,
        isForgotError: state.auth.isForgotError,
        strings: state.language.strings,
        isError: state.api.isError,
    }
}

const ConnectedEmailVerificationScreen = connect(
    mapStateToProps
)(EmailVerificationScreen);

export default withRouter(ConnectedEmailVerificationScreen);